import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=05704db4&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=05704db4&prod&lang=scss"
import style1 from "./ContactForm.vue?vue&type=style&index=1&id=05704db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05704db4",
  null
  
)

export default component.exports